import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import parse from "html-react-parser";
import cx from "classnames";

interface TaskManagementRestrictionBannerProps {
  bannerTextHtml: string;
  className?: string;
}

function TaskManagementRestrictionBanner({
  bannerTextHtml,
  className,
}: TaskManagementRestrictionBannerProps) {
  return (
    <div
      className={cx(
        "flex items-center p-4 mb-4 rounded-md bg-sky-50 text-sky-700 text-sm",
        className
      )}
    >
      <FontAwesomeIcon
        icon={faInfoCircle}
        className="flex-shrink-0 text-sky-600 mr-3"
      />
      <div className="styled-list">{parse(bannerTextHtml)}</div>
    </div>
  );
}

export default TaskManagementRestrictionBanner;
